.wrap {
  max-width: 960px;
  margin: 0 auto;
}

.main {
  padding: 2em;
  composes: wrap;
}
